<!-- =========================================================================================
  File Name: ng.vue
  Description: Setting Ng
========================================================================================== -->

<template>
  <div id="setting-ng">

    <vx-card title="对接设置">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mb-base">
          <vs-input class="w-full" v-model="setting.ng_url" label-placeholder="对接URL" />
        </div>
        <div class="vx-col md:w-1/3 w-full mb-base">
          <vs-input class="w-full" v-model="setting.ng_account" label-placeholder="账号" />
        </div>
        <div class="vx-col md:w-1/3 w-full mb-base">
          <vs-input class="w-full" v-model="setting.ng_key" label-placeholder="密匙" />
        </div>
      </div>
      <div class="w-full ml-auto">
        <vs-button @click="submit">提交</vs-button>
      </div>
    </vx-card>

    <div class="vx-row mt-4">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="开关设置">
          <vs-collapse v-for="(item, index) in list" :key="index" type="margin">
            <vs-collapse-item>
              <div slot="header">{{item.name}}</div>
              <div class="flex items-center flex-wrap">
                <vs-checkbox class="w-32 mb-2" v-model="item2.isShow" v-for="(item2, index2) in item.list" :key="index2">{{item2.name}}</vs-checkbox>
              </div>
            </vs-collapse-item>
          </vs-collapse>
          <div class="w-full ml-auto">
            <vs-button class="ml-3 mt-2" @click="submit">提交</vs-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="大图标设置">
          <vs-collapse v-for="(item, index) in list" :key="index" type="margin">
            <vs-collapse-item>
              <div slot="header">{{item.name}}</div>
              <div class="flex items-center flex-wrap">
                <vs-checkbox class="w-32 mb-2" v-model="item2.isBig" v-for="(item2, index2) in item.list" :key="index2">{{item2.name}}</vs-checkbox>
              </div>
            </vs-collapse-item>
          </vs-collapse>
          <div class="w-full ml-auto">
          	<vs-button class="ml-3 mt-2" @click="submit">提交</vs-button>
          </div>
        </vx-card>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  data() {
    return {
      setting: {
        ng_url: '',
        ng_account: '',
        ng_key: '',
        ng_list: [],
        ng_big_icon: []
      },
      list: []
    }
  },
  methods: {
    submit () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.setting = JSON.stringify(this.setting)
      postdata.list = JSON.stringify(this.list)
      this.$utils.post('setting-ngDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
      })
    }
  },
  mounted () {
    // 读取设置
    this.$utils.post('setting-ng', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.setting = res.setting
      let t, l, b
      for (const i in res.type) {
        t = res.type[i]
        l = res.setting.ng_list[t.shortname]
        b = res.setting.ng_big_icon[t.shortname]
        for (let k = 0; k < t.list.length; k++) {
          res.type[i].list[k] = { name: t.list[k] }
          res.type[i].list[k].isShow = (!l || l.indexOf(t.list[k].name.toUpperCase()) === -1) ? false : true
          res.type[i].list[k].isBig = (!b || b.indexOf(t.list[k].name.toUpperCase()) === -1) ? false : true
        }
      }
      this.list = res.type
    })
  }
}
</script>
